<script>
import appConfig from "@/app.config";
import {
  isMobile,
  isTablet,
  isAndroid,
  isIOS,
  browserName,
} from "mobile-device-detect";
export default {
  components: {},
  props: {
    data: Object,
  },
  data() {
    return {
      assetsPath: appConfig.assetsPath,
      browsers: appConfig.browsers,
      isMobile,
      isTablet,
      browserName,
      showVideos: true,
    };
  },
  mounted() {
    this.checkBrowser();
  },
  methods: {
    getImgUrl(img) {
      if (img) {
        if (img.indexOf("http") > -1) {
          return img;
        }
        return this.assetsPath + "images/" + img;
      }
      return "";
    },
    getVideoUrl(url) {
      console.log("url", url);
      if (url) {
        if (url.indexOf("http") > -1) {
          return url;
        }
        console.log("this.assetsPath + url", this.assetsPath + url);
        return this.assetsPath + url + ".mp4";
      }
      return "";
    },
    checkBrowser() {
      const isFound = this.browsers.find(
        (browser) => browser.name == this.browserName
      );
      if (isFound && (this.isMobile || this.isTablet)) {
        this.showVideos = false;
      } else {
        this.showVideos = true;
      }
    },
  },
};
</script>

<template>
  <div :class="$style.gameCard" class="d-flex flex-column">
    <div
      :class="$style.featuredBadge"
      class="d-flex flex-row align-items-center justify-content-center"
    >
      <img
        :src="assetsPath + 'images/icons/multi-corner-star-icon.svg'"
        alt=""
        class="mr-2"
      />
      <span> {{ $t("gameCoverCard.featured") }}</span>
    </div>
    <div :class="[$style.cover]" class="w-100">
      <div
        :class="$style.coverBg"
        v-bind:style="{ backgroundImage: 'url(' + getImgUrl(data.cover) + ')' }"
      >
        <video
          width="320"
          height="240"
          muted
          autoplay
          loop
          :class="$style.videoPlayer"
          v-if="data.videoUrl && showVideos"
          playsinline
        >
          <source :src="getVideoUrl(data.videoUrl)" type="video/mp4" />
          <source :src="getVideoUrl(data.videoUrl)" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div :class="$style.gameLogo">
        <img :src="getImgUrl(data.logo)" alt="" />
      </div>
    </div>
    <div :class="$style.content" class="px-4 text-center d-inline-block">
      <h3>{{ data.title }}</h3>
      <div :class="$style.overflowText">
        <p>{{ data.abstract }}</p>
      </div>
      <!-- <div class="d-inline-block w-100">
        <a :href="GLOBAL.hrefLink(data.route)"  class="btn btn-warning btn-lg rounded-half">
          {{ $t("gameCoverCard.learn") }}
        </a>
      </div> -->
    </div>
  </div>
</template>

<style lang="scss" module>
@import "@/design/_colors.scss";
@import "@/design/_fonts.scss";

.gameCard {
  position: relative;
  border-radius: 14px;
  overflow: hidden;
  background-color: $white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
  .videoPlayer {
    width: 101%;
    object-fit: cover;
    border-radius: 14px 14px 0 0;
  }
  .cover {
    height: 200px;
    position: relative;
    border-radius: 14px 14px 0 0;
  }
  .coverBg {
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    display: inline-block;
    width: 100%;
    height: 100%;
    transition: 0.3s;
    overflow: hidden;
    border-radius: 14px 14px 0 0;
  }
  .gameLogo {
    position: absolute;
    width: 80px;
    height: 80px;
    overflow: hidden;
    border-radius: 14px;
    left: 0;
    right: 0;
    bottom: -40px;
    margin: 0 auto;
    z-index: 1;
  }
  .content {
    padding-top: 70px;
    padding-bottom: 40px;
    h3 {
      margin-bottom: 20px;
      font-size: 22px;
      font-family: $family-bold;
    }
    .overflowText {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      height: 3.2em;
      margin-bottom: 30px;
      p {
        font-size: 17px;
      }
    }
  }
}
.featuredBadge {
  position: absolute;
  top: 20px;
  left: 20px;
  background-color: $bgcolor-featured-badge;
  color: $white;
  border-radius: 50px;
  padding: 6px 9px;
  z-index: 1;
  span {
    font-size: 15px;
    font-family: $family-bold;
  }
}

@media only screen and (max-width: 767px) {
  .gameCard {
    .cover {
      height: 150px;
    }
    .content {
      padding-top: 60px;
      padding-bottom: 30px;
      h3 {
        font-size: 20px;
        margin-bottom: 15px;
      }
      .overflowText {
        margin-bottom: 24px;
      }
    }
  }
}
</style>
